module.exports = __webpack_public_path__ + "static/10400556_21574812223_5126_n-87e7b8f458f0dab61f54a82e53979a48.jpg";